import React, { useState } from 'react';
import { Row, Col, Menu, Button, Spin } from 'antd';
import { Area } from '@ant-design/plots';
import { queryOpenAPIDeveloperBindUserByDate ,queryOpenAPIDeveloperSoultionsByMonths} from "../gqls";
import Client from '../../../../../lib/gqlClient';
import getWantTimestamp from '../../../../../lib/utils/times'
import moment from 'moment-timezone';
const AppDeveloperChartPage = (props) => {
    const [isSelectUserOrPushLoading, setIsSelectUserOrPushLoading] = useState(false)//是否正在加载
    const [userOrPushSelectItem, setUserOrPushSelectItem] = useState(3)//默认显示全年 1本月 2本季度 3全年
    const [key, setKey] = useState('1')
    const [userOrPushName, setUserOrPushName] = useState('绑定用户数趋势 ')
    const [userOrPushNameItem, setUserOrPushNameItem] = useState('绑定用户数')
    const [listData, setListData] = useState([])
    React.useEffect(() => {
        isGetSelectDeveloper(userOrPushSelectItem,key)
    }, [])
    function onClick(e) {
        console.log(e)
        setKey(e.key)
        switch (e.key) {
            case "1":
                //绑定用户数
                isGetSelectDeveloper(userOrPushSelectItem,e.key);
                break;
            case "2":
                //Push量
                isGetSelectDeveloper(userOrPushSelectItem,e.key);
                break;
            case "3":
                //绑定用户数
                isGetSelectDeveloper(userOrPushSelectItem,e.key);
                break;
            case "4":
                //Push量
                isGetSelectDeveloper(userOrPushSelectItem,e.key);
                break;
        }
    }
    function btnUserOrPush(type) {
        isGetSelectDeveloper(type,key)
    }
    function isGetSelectDeveloper(type,key) {
        setUserOrPushSelectItem(type)
        console.log(11,type,key)
        var start = ''
        switch (type) {
            case 1:
                start = getWantTimestamp("thisYearDayZero");
                break;
            case 2:
                start = getWantTimestamp("threeMonthDayZero");
                break;
            case 3:
                start = getWantTimestamp("thisYearDayZero");
                break;
            default: {
                console.log("类型错误");
                return start = '';
            }
        }
        var months = []
        switch (type) {
            case 1:
                months = getWantTimestamp("thisYearDayZero");
                break;
            case 2:
                months = getWantTimestamp("threeMonthDayZeroList");
                break;
            case 3:
                let month = moment().utc().month() + 1;
                let list = []
                for (let index = 0; index < month; index++) {
                    list[index] = index + 1
                }
                months = list;
                break;
            default: {
                console.log("类型错误");
                return months = [];
            }
        }
        var end = getWantTimestamp("nowData");
        let year = moment().utc().year();
        setIsSelectUserOrPushLoading(true)
        if (key==='1') {
            setUserOrPushName('绑定用户数趋势')
            setUserOrPushNameItem('绑定用户数')
            getOpenAPIDeveloperBindUserByDate(start, end,year)
        } else if (key==='2') {
            setUserOrPushName('Push量趋势')
            setUserOrPushNameItem('Push量')
            getOpenAPIDeveloperSoultionsByMonths(year, months,key)
        }else if (key==='3') {
            setUserOrPushName('Pull量趋势')
            setUserOrPushNameItem('Pull量')
            getOpenAPIDeveloperSoultionsByMonths(year, months,key)
        }else if (key==='4') {
            setUserOrPushName('Pubsub量趋势')
            setUserOrPushNameItem('Pubsub量')
            getOpenAPIDeveloperSoultionsByMonths(year, months,key)
        }
    }
    function getOpenAPIDeveloperBindUserByDate(start, end,year) {
        //默认显示全年 1本月 2本季度 3全年
        Client(
            queryOpenAPIDeveloperBindUserByDate,
            {
                appUserId: props.appUserId,
                startDate: start,
                endDate: end
            }
        ).then((res) => {
            console.log(res)
            if (res !== null) {
                const list = res.data.openAPIDeveloperBindUserByDate
                let data = [{}];
                list.map((item, index) => {
                    data[index] = {
                        日期: year + "-" + item.month,
                        数量: item.count,
                    }
                })
                setListData(data)
                setIsSelectUserOrPushLoading(false)
            }
        }).catch(e => {
            // console.log(e);
            setListData()
            setIsSelectUserOrPushLoading(false)
        })
    }
    function getOpenAPIDeveloperSoultionsByMonths(year, months,key) {
        //默认显示全年 1本月 2本季度 3全年
        Client(
            queryOpenAPIDeveloperSoultionsByMonths,
            {
                appUserId: props.appUserId,
                year: year,
                months: months
            }
        ).then((res) => {
            console.log(res)
            if (res !== null) {
                let data = [{}];
                if(key==='2'){
                   res.data.openAPIDeveloperSoultionsByMonths.push.map((item, index) => {
                    data[index] = {
                        日期: year + "-" + item.month,
                        数量: item.count,
                    }
                })
                }else if(key==='3'){
                    res.data.openAPIDeveloperSoultionsByMonths.pull.map((item, index) => {
                        data[index] = {
                            日期: year + "-" + item.month,
                            数量: item.count,
                        }
                    })
                }else if(key==='4'){
                    res.data.openAPIDeveloperSoultionsByMonths.pubsub.map((item, index) => {
                        data[index] = {
                            日期: year + "-" + item.month,
                            数量: item.count,
                        }
                    })
                }
                setListData(data)
                setIsSelectUserOrPushLoading(false)
            }
        }).catch(e => {
            // console.log(e);
            setListData()
            setIsSelectUserOrPushLoading(false)
        })
    }
    return (

        <div style={{ height: '404px', padding: '0px', marginTop: '15px', backgroundColor: 'white', borderRadius: '2px' }}>

            <div style={{ height: '55px', padding: '0px', }}>
                <Row>
                    <Col span={12}>
                        <Menu 
                            selectedKeys={key}
                            mode="horizontal"
                            style={{ justifyContent: 'start' }}
                            items={itemsOne}
                            onClick={onClick}
                            
                        >
                        </Menu>
                    </Col>
                    <Col span={12} style={{ display: 'flex', justifyContent: 'right', alignItems: 'center', }}>
                        <Button className="btn" onClick={() => btnUserOrPush(2)} type="text" style={{ color: (userOrPushSelectItem === 2 ? '#2657F9' : '#000'), border: 'none' }}>本季度</Button>
                        <Button className="btn" onClick={() => btnUserOrPush(3)} type="text" style={{ border: 'none', color: (userOrPushSelectItem === 3 ? '#2657F9' : '#000'), marginRight: '18px' }}>本年</Button>
                    </Col>
                </Row>
                <div style={{ height: '1px', backgroundColor: '#E8E8E8' }} />
            </div>
            <a style={{ marginLeft: '56px', marginTop: '24px', display: 'block', fontSize: '16px', lineHeight: '24px', color: ' #2657F9' }}>{userOrPushName}</a>
            <Spin size="large" tip="Loading..." spinning={isSelectUserOrPushLoading}>
                <Area{...{
                    data: listData,
                    xField: '日期',
                    yField: '数量',
                    xAxis: {
                        range: [0, 1],
                    },
                    yAxis: {
                        maxTickCount:10,
                    },
                    // isPercent:true,//百分比
                    isStack: true,//堆积面积
                    smooth: true,
                    fill: '#2657F9',

                }} style={{ height: '246px', marginTop: '20px', marginBottom: '33px', marginLeft: '99px', marginRight: '94px' }} />
            </Spin>

        </div>
    )

}
function getItem(label, key,) {
    return {
        key,
        label,
    };
}
const itemsOne = [
    getItem('绑定用户数', '1'),
    getItem('Push量', '2'),
    getItem('Pull量', '3'),
    getItem('Pubsub量', '4'),

];
export default AppDeveloperChartPage